import React from 'react';
import PropTypes from 'prop-types';
import Tab from '../Tab';

function TabList({ children }) {
  return (
    <div className="ui-tabs">
      {children}
    </div>
  );
}

TabList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.instanceOf(Tab)).isRequired,
};

export default TabList;
